import { Routes, Route, Navigate } from "react-router-dom";
import AddStaffForm from "../pages/AdminPortal/Addstaff";
import StaffProfile from "../pages/AdminPortal/StaffProfile";
import StaffManagement from "../pages/AdminPortal/StaffManagement";
import LoanApplicationView from "../pages/AdminPortal/LoanApplicationView";
import UniversalAnalysers from "../pages/AdminPortal/UniversalAnalysers";
import BankingPartnerForm from "../components/AdminPortal/BankingPartnerDetails/AddCategory/BankingPartnerForm";
import Customer from "../pages/AdminPortal/Customer";
import AffiliatePartnerForm from "../pages/AdminPortal/AffiliatedNew";
import AffiliateProfilePage from "../pages/AdminPortal/AffiliatedProfile";
import AffiliateDashboard from "../pages/AdminPortal/AffiliatedPartner";
import FinancialTracking from "../pages/AdminPortal/FinancialTracking";
import SalesDashboard from "../pages/AdminPortal/SalesDashboard";
import AutomatedCommunicationSystem from "../pages/AdminPortal/AutoMessage";
import PartnerDetails from "../pages/AdminPortal/PartnerDetails";
import MainLayout from "./MainLayout";
import BankingPartners from "../pages/AdminPortal/BankingPartners";
import { Toaster } from 'react-hot-toast';
import NewDashboard from "../pages/AdminPortal/NewDashboard";
import CommunicationCenter from "../pages/AdminPortal/CommunicationCenter";
import AdminSettings from "../pages/AdminPortal/AdminSettings";
const AdminLayout = () => {
  return (
    <MainLayout>
      <Routes>
        {/* Admin Routes */}
        {/* <Route path="dashboard" element={<Dashboard />} /> */}
        <Route path="dashboard" element={<NewDashboard />} />
        <Route path="staff" element={<StaffManagement />} />
        <Route path="staff/add" element={<AddStaffForm />} />
        <Route path="staff/:id" element={<StaffProfile />} />
        <Route path="settings" element={<AdminSettings />} />

        {/* Banking Partner Routes */}
        <Route path="banking-partner" element={<BankingPartners />} />
        <Route
          path="banking-partner/add-partners"
          element={<BankingPartnerForm />}
        />
        <Route path="banking-partner/:id" element={<PartnerDetails />} />

        {/* CRM Routes */}
        <Route path="customers" element={<Customer />} />
        <Route
          path="loan-applications/approval/:id"
          element={<LoanApplicationView />}
        />
        <Route
          path="universal-analysers/:id"
          element={<UniversalAnalysers />}
        />

        <Route path="loan-applications" element={<Customer />} />

        {/* Affiliate Routes */}
        <Route path="affiliate-partners" element={<AffiliateDashboard />} />
        <Route
          path="affiliate-partners/new"
          element={<AffiliatePartnerForm />}
        />
        <Route
          path="affiliate-partners/:id"
          element={<AffiliateProfilePage />}
        />
        <Route path="affiliates" element={<AffiliateDashboard />} />

        {/* Other Routes */}
        <Route path="reports" element={<SalesDashboard />} />
        <Route path="financials" element={<FinancialTracking />} />
        <Route path="communication" element={<CommunicationCenter />} />
        <Route path="messages" element={<AutomatedCommunicationSystem />} />

        {/* 404 Route */}
        <Route
          path="*"
          element={
            <div className="flex items-center justify-center min-h-screen bg-[#131313] text-white p-4">
              <div className="text-center">
                <h1 className="text-5xl font-bold text-[#FFCA20] mb-4">404</h1>
                <h2 className="text-2xl mb-4">Page Not Found</h2>
                <p className="text-gray-400 mb-6">
                  The page you are looking for doesn't exist or has been moved.
                </p>
                <a
                  href="/admin/dashboard"
                  className="bg-[#FFCA20] hover:bg-yellow-600 text-black font-medium py-2 px-6 rounded"
                >
                  Go to Dashboard
                </a>
              </div>
            </div>
          }
        />
      </Routes>
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
    </MainLayout>
  );
};

export default AdminLayout;
